<pmd-navbar class="khar_navbar navbar-expand-xl fixed-top bg-white demo-navbar"
	id="navbar">
	<div class="d-flex justify-content-between w-100 align-items-center px-3 h-100 demo-navbar-inner">
		<a [routerLink]="['/purchase-manager-demo']"
			class="demo-navbar-title-block"
			aria-label="Purchase Manager Demo">
			<div class="demo-navbar-icon">
				<i class="material-icons">shopping_cart</i>
			</div>
			<div class="demo-navbar-text">
				<span class="demo-navbar-title">Purchase Manager</span>
				<span class="demo-navbar-subtitle">Search multiple items, SKUs, or commodities instantly.</span>
			</div>
		</a>
		<img src="assets/images/PurchaseLogo.svg"
			alt="Petpooja Purchase"
			class="demo-navbar-logo">
	</div>
</pmd-navbar>

<main class="home-layout demo-home-layout"
	aria-label="Purchase Manager Demo"
	id="mainContent">
	<div class="d-flex flex-1 w-100">
		<div class="main-block">
			<div class="content_block">
				<router-outlet></router-outlet>
			</div>
		</div>
	</div>
</main>
